import React from 'react';
import styled from 'styled-components';
import {LoadingPageSpinner} from '../../../../atoms/Loaders/LoadingPageSpinner';

export const FullPageSpinner = ({className}: {className?: string} = {}) => {
  return (
    <StyledLoadingBannerWrapper className={className}>
      <StyledLoadingBanner />
    </StyledLoadingBannerWrapper>
  );
};

const StyledLoadingBannerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  height: unset;
  z-index: 100;
`;

const StyledLoadingBanner = styled(LoadingPageSpinner)`
  position: sticky;
  top: 0;
`;
